<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle r="15" transform="matrix(-1 0 0 1 15 15)" fill="#EFE8FA"/>
<path d="M18.3333 11L11 18.3333" stroke="#6C44A8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M11 11L18.3333 18.3333" stroke="#6C44A8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
